import { OIDC_PROVIDER } from '../../network/httpClients/OIDCAuthenticationClient/consts';
import { QUERY_PARAMS } from '../../routes/consts';
import { fetchAuthorizeEndpoint } from '../../utils/authentication';
import {
  getSessionIdFromSessionStorage,
  getTraceIdFromSessionStorage,
  getQueryParam,
  buildSearchParams,
} from '../../utils/url';

/**
 * Custom hook for sending email authentication requests.
 */
export const useEmailSender = () => {
  const sendEmail = async (email: string) => {
    const enterpriseUserName = getQueryParam(QUERY_PARAMS.ENTERPRISE_USER_NAME);

    const additionalParams = buildSearchParams({
      [QUERY_PARAMS.PROVIDER]: OIDC_PROVIDER.EMAIL,
      [QUERY_PARAMS.EMAIL]: email,
      [QUERY_PARAMS.SESSION_ID]: getSessionIdFromSessionStorage(),
      [QUERY_PARAMS.TRACE_ID]: getTraceIdFromSessionStorage(),
      [QUERY_PARAMS.ENTERPRISE_USER_NAME]: enterpriseUserName,
    });

    await fetchAuthorizeEndpoint(additionalParams);
  };

  return { sendEmail };
};
